import {
  add,
  eachMonthOfInterval,
  eachDayOfInterval,
  format,
  isSameMonth,
  isSunday,
  isMonday,
  isTuesday,
  isWednesday,
  isThursday,
  isFriday,
  isSaturday,
  isWeekend,
} from 'date-fns'

const currentDate = new Date()

const genArgsOfSchedule = state => {
  return {
    startDate: new Date(),
    term: state.displayTerm,
  }
}

const OptionsScheduleRange = {
  TwoWeeks: { displayName: '2週', dateObject: { days: 14 } },
  OneMonth: { displayName: '1ヶ月', dateObject: { months: 1 } },
  TwoMonths: { displayName: '2ヶ月', dateObject: { months: 2 } },
  ThreeMonths: { displayName: '3ヶ月', dateObject: { months: 3 } },
  SixMonths: { displayName: '6ヶ月', dateObject: { months: 6 } },
}

const getJPWeekDay = date => {
  switch (true) {
    case isSunday(date):
      return '日'
    case isMonday(date):
      return '月'
    case isTuesday(date):
      return '火'
    case isWednesday(date):
      return '水'
    case isThursday(date):
      return '木'
    case isFriday(date):
      return '金'
    case isSaturday(date):
      return '土'
    default:
      return ''
  }
}

const makeMonthsIntervalRange = (
  startDate = currentDate,
  term,
) => {
  const endDataObject =
    term && OptionsScheduleRange[term]
      ? add(startDate, OptionsScheduleRange[term].dateObject)
      : currentDate
  const intervalRange = {
    start: startDate,
    end: endDataObject,
  }
  const monthsInterval = eachMonthOfInterval(intervalRange)
  const daysInterval = eachDayOfInterval(intervalRange)

  return {
    monthsInterval,
    daysInterval,
  }
}

const getMonthlyScheduleData = ({startDate = currentDate, term}) => {
  const { monthsInterval, daysInterval } = makeMonthsIntervalRange(
    startDate,
    term,
  )
  return generateMonthDaysList(monthsInterval, daysInterval)
}

const generateMonthDaysList = (monthsInterval, daysInterval) => {
  return monthsInterval.reduce((acc, cur) => {
    const days = daysInterval
      .filter(d => isSameMonth(cur, d))
      .reduce(
        (a, c) => [
          ...a,
          {
            ymd: format(c, 'yyyyMMdd'),
            isHoliday: isWeekend(c),
            format: `${format(c, 'dd')}(${getJPWeekDay(c)})`,
          },
        ],
        [],
      )
    return [
      ...acc,
      {
        month: format(cur, 'yyyy/MM'),
        days,
      },
    ]
  }, [])
}

export default {
  namespaced: true,
  state: {
    selectDate: new Date(),
    displayTerm: 'TwoMonths',
  },
  getters: {
    monthlySchedule: state => {
      return getMonthlyScheduleData(genArgsOfSchedule(state))
    },
  },
}
